import React from 'react';
import { Reveal } from './Reveal';
type Bonus = {
  label: string;
  title: string;
  image: string;
};
const bonuses: Bonus[] = [{
  label: 'Bonus 01',
  title: 'Kit de Cartographie Systémique Illustré',
  image: 'https://cdn.magicpatterns.com/uploads/1Y7y2nvPzqKmgGMeFHwCVB/ChatGPT_Image_17_ago_2026,_08_55_16_p.m..png'
}, {
  label: 'Bonus 02',
  title: '24 Cartes de Phrases de Guérison — Édition Deluxe',
  image: 'https://cdn.magicpatterns.com/uploads/mqrvtb1J5F3C623zY5tyDa/ChatGPT_Image_17_ago_2026,_08_55_36_p.m..png'
}, {
  label: 'Bonus 03',
  title: 'Génogramme de Solution Professionnel',
  image: 'https://cdn.magicpatterns.com/uploads/oChb2Ee7R2Fbdta1UCtbM7/ChatGPT_Image_17_ago_2026,_08_55_44_p.m..png'
}, {
  label: 'Bonus 04',
  title: 'Scripts de Méditation et de Connexion au Champ',
  image: 'https://cdn.magicpatterns.com/uploads/aKLrG9b3THUJ2JYdT8BzJQ/ChatGPT_Image_17_ago_2026,_08_55_51_p.m..png'
}, {
  label: 'Bonus 05',
  title: 'Journal d’Intégration — 30 Jours de Guérison Systémique',
  image: 'https://cdn.magicpatterns.com/uploads/2YPcVkgjoXDXqKuAdSMRNh/ChatGPT_Image_17_ago_2026,_08_55_59_p.m..png'
}];
export function Bonuses() {
  return <section className="w-full bg-mist px-4 py-16 sm:py-20" data-id="element-17" data-mp="3r5gkfy6hl8ci">
      <div className="mx-auto max-w-6xl" data-id="element-18" data-mp="3n5eng2bp533k">
        <Reveal className="text-center" data-id="element-19" data-mp="3n5ojo7nc46hp">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-amber" data-id="element-20" data-mp="2zfkhm4psoest">
            Inclus avec la collection complète
          </p>
          <h2 className="mx-auto mt-3 max-w-4xl font-serif text-[2.75rem] leading-[1.02] text-navy sm:text-6xl" data-id="element-21" data-mp="2uhsml1tuscke">
            🎁 5 Bonus cliniques exclusifs <span className="text-amber" data-id="element-22" data-mp="33h5nv77tpuu1">offerts avec votre achat</span>
          </h2>
          <span className="mx-auto mt-6 block h-px w-24 bg-amber/60" data-id="element-23" data-mp="33j9ye8089s3a" />
          <p className="mx-auto mt-5 max-w-2xl text-sm text-slate sm:text-base" data-id="element-24" data-mp="nogg98fphhu1">
            Valeur individuelle de 15 EUR chacun — inclus gratuitement pendant le lancement.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-25" data-mp="3ciek0y0tdkwg">
          {bonuses.map((bonus, index) => <Reveal key={bonus.label} delay={index % 2 * 0.05} className={`h-full ${index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.75rem)]' : ''}`} data-id="element-26" data-mp="3hg6d3vd73d28" data-mpi={index}>
              <li className="h-full overflow-hidden rounded-2xl border border-amber bg-surface shadow-elevated" data-id="element-27" data-mp="2tsf3izj1he4n">
                <img src={bonus.image} alt={`${bonus.label} — ${bonus.title}`} className="block h-auto w-full object-cover" loading="lazy" data-id="element-28" data-mp="2xtih1fdm6y2p" />
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}